const zIndexes = {
  buttonsWithDropdown: 100,
}

export default zIndexes
